<template>
    <div class="shiftspotlist-popup" v-bind:class="{large: popupData.assigned}" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="content" style="font-size:11px;">
            <div class="full">
                <div class="header_column">
                        {{ popupData.date }}
                    </div>
                    <div v-if="!popupData.assigned" class="full">
                    <div class="entry-header">
                            {{ $t('roster.comp.openShifts') }}
                        </div>
                    <div v-for="p, index in popupData.unassigned" v-bind:key="index+p.label" v-bind:class="{entry: index < popupData.unassigned.length - 1, 'entry-split': index == popupData.unassigned.length - 1 || (index < popupData.unassigned.length - 1 && popupData.unassigned[index+1].bold)}">
                        <div class="left_column" v-bind:class="{bold: p.bold}">
                            {{p.label}}
                        </div>
                        <div class="right_column" v-bind:class="{bold: p.bold}">
                            {{ p.value }}
                        </div>
                    </div>
                    <div class="entry last">
                        <div class="left_column bold">
                            {{ popupData.unassignedTotal.label }}
                        </div>
                        <div class="right_column bold">
                            {{ popupData.unassignedTotal.value }}
                        </div>
                    </div>
                </div>
                <div v-if="popupData.assigned" class="half">
                    <div class="entry-header">
                        {{ $t('roster.view.plannedHours') }}
                        </div>
                    <div v-for="p, index in popupData.planned" v-bind:key="p.label" v-bind:class="{entry: index < popupData.planned.length - 1, 'entry-split': index == popupData.planned.length - 1}">
                        <div class="left_column">
                            {{p.label}}
                        </div>
                        <div class="right_column">
                            {{ p.value }}
                        </div>
                    </div>
                    <div class="entry last">
                        <div class="left_column bold">
                            {{ popupData.plannedTotal.label }}
                        </div>
                        <div class="right_column bold">
                            {{ popupData.plannedTotal.value }}
                        </div>
                    </div>
                </div>
                <div v-if="popupData.assigned" class="half">
                    <div class="entry-header">
                        {{ $t('roster.view.punchedHours') }}
                        </div>
                    <div v-for="p, index in popupData.actual" v-bind:key="p.label" v-bind:class="{entry: index < popupData.actual.length - 1, 'entry-split': index == popupData.actual.length - 1}">
                        <div class="left_column">
                            {{p.label}}
                        </div>
                        <div class="right_column">
                            {{ p.value }}
                        </div>
                    </div>
                    <div class="entry last">
                        <div class="left_column bold">
                            {{ popupData.actualTotal.label }}
                        </div>
                        <div class="right_column bold">
                            {{ popupData.actualTotal.value }}
                        </div>
                    </div>
                    <div class="entry-header">
                        {{ $t('roster.view.crewManagement') }}
                    </div>
                    <div class="entry">
                        <div class="left_column">
                            {{ $t('roster.view.plannedCrew') }}
                        </div>
                        <div class="right_column">
                            {{ popupData.crewvsmanagement.plannedCrew }}
                        </div>
                    </div>
                    <div class="entry-split">
                        <div class="left_column">
                            {{ $t('roster.view.plannedMgmt') }}
                        </div>
                        <div class="right_column">
                            {{ popupData.crewvsmanagement.plannedManagement }}
                        </div>
                    </div>
                    <div class="entry">
                        <div class="left_column">
                            {{ $t('roster.view.punchedCrew') }}
                        </div>
                        <div class="right_column">
                            {{ popupData.crewvsmanagement.actualCrew }}
                        </div>
                    </div>
                    <div class="entry">
                        <div class="left_column">
                            {{ $t('roster.view.punchedMgmt') }}
                        </div>
                        <div class="right_column">
                            {{ popupData.crewvsmanagement.actualManagement }}
                        </div>
                    </div>

                    <div class="entry-header">
                            {{ $t('roster.view.productivity') }}
                        </div>
                    <div class="entry-split">
                        <div class="left_column">
                            {{ $t('roster.view.keyFigure') }}
                        </div>
                        <div class="right_column">
                            {{ popupData.productivity.indicator }}
                        </div>
                    </div>
                    <div class="entry">
                        <div class="left_column">
                            {{ $t('roster.view.productivityTarget') }}
                        </div>
                        <div class="right_column">
                            {{ popupData.productivity.planned }}
                        </div>
                    </div>
                    <div class="entry">
                        <div class="left_column">
                            {{ $t('roster.view.productivityActual') }}
                        </div>
                        <div class="right_column">
                            {{ popupData.productivity.actual }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'shiftspotlistpopup',
        components: {
        },
        data(){
            return{
                toggled: false,
                elRelative: null,
                events: [],
                posx: 0,
                posy: 0,
                offsetY: 0,
                employee: null,
                mode: 0,
                planRange: "",
                istRange: "",
                popupData: {}
            }
        },
        created () {
        },
        destroyed(){
        },
        computed: {
        },
        methods: {
            Close(){
                //if($(window.mouse.element).closest('.shiftspotlist-popup').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },
            Init(data, elRelative, offsetY = 0){
                this.toggled = true;
                this.popupData = data;
                if(elRelative){
                    this.elRelative = elRelative;
                    this.offsetY = offsetY;
                    this.Reposition();
                }
            },
            Reposition(){
                var view = this;
                requestAnimationFrame(function(){
                    if(!view.elRelative) return;
                    var box = view.elRelative.getBoundingClientRect();
                    var wWidth = $(document).width();
                    var overflow = box.left + 500 - wWidth;
                    if(overflow > 0){
                        view.posx = box.left - overflow;// + box.width / 2;
                    }else{
                        view.posx = box.left;// + box.width / 2;
                    }

                    view.posy = box.top + 16 + view.offsetY;
                    view.$forceUpdate();
                });
            },
        },
        mounted() {
            $('body').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



    .shiftspotlist-popup{
        position:fixed;
        display:inline-block;
        max-height: 650px;
        width: 250px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: var(--bg);
        color: var(--col-label-default);
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        border: 1px solid #a5a5a5;
        padding: 15px;

        top: 120px;
        left: 78px;
        overflow-y: auto;
    }

    .shiftspotlist-popup.large{
        width: 500px;
    }

    .shiftspotlist-popup .half{
        width: 50%;
        padding: 0px 10px;
    }

    .shiftspotlist-popup .entry{
        margin-top: 0px;
    }

    .shiftspotlist-popup .entry.dimmed{
        color: var(--contrast-5) !important;
        margin-top: -2px;
        font-size: 10px;
    }

    .shiftspotlist-popup .entry-split-light.dimmed{
        color: var(--contrast-5) !important;
        margin-top: -2px;
        font-size: 10px;
    }

    .shiftspotlist-popup .entry.last{
        margin-bottom: 8px;
    }

    .shiftspotlist-popup .entry.bold{
        font-family: DistrictProBold !important;
        font-weight: bold;
    }

    .shiftspotlist-popup .entry-split.last{
        margin-bottom: 8px;
    }

    .shiftspotlist-popup .entry-split{
        border-bottom: 1px solid var(--contrast-4);
        padding-bottom: 2px;
        margin-bottom: 2px !important;
    }

    .shiftspotlist-popup .entry-split-light{
        border-bottom: 0.5px solid var(--contrast-1);
        padding-bottom: 1px;
        margin-bottom: 1px !important;
    }

    .shiftspotlist-popup .entry-header{
        border-bottom: 1px solid var(--contrast-4);
        padding-bottom: 2px;
        margin-bottom: 2px;
        font-family: DistrictProBold !important;
        font-weight: bold;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }

    .large .header_column {
        color: var(--md);
        display:inline-block;
        width: calc(100% - 20px);
        padding-bottom: 2px;
        margin: 0px 10px 6px 10px;
        font-family: DistrictProBold;
        font-weight: bold !important;
        font-size: 14px;
        border-bottom: 2px solid var(--md);
    }

    .header_column {
        color: var(--md);
        display:inline-block;
        width: 100%;
        padding-bottom: 2px;
        margin: 0px 0px 6px 0px;
        font-family: DistrictProBold;
        font-weight: bold !important;
        font-size: 14px;
        border-bottom: 2px solid var(--md);
    }

    .left_column.bold{
        font-family: DistrictProBold !important;
        font-weight: bold;
    }

    .right_column.bold{
        font-family: DistrictProBold !important;
        font-weight: bold;
    }

    .left_column {
        display:inline-block; width: 100px; text-align:left;
    }
    .right_column {
        display:inline-block; width: 100px; text-align:right;
    }

</style>
